export default __webpack_public_path__ + "static/media/dual-arrow.580432c7.svg";